import {useCallback} from 'react'
import {gql, useMutation} from '@apollo/client'
import myUniversity from './queryResults/myUniversity'

export default (onSuccess, onError = () => {}) => {
  const [mutation, {data, error, loading}] = useMutation(
    gql`
        mutation(
              $studentId: ID!
              $universityId: ID!
              $status: UniversityStatus!
              ){
                setStatusUniversity (
                    universityId: $universityId
                    studentId: $studentId
                    status: $status
                ) {
                    ${myUniversity}
                }
              }
      `,
  )
  const submit = useCallback(
    (obj) => {
      mutation({variables: obj})
        .then((result) => {
          onSuccess(result)
        })
        .catch((e) => {
          onError(e)
        })
    },
    [mutation, onSuccess, onError],
  )
  return {loading, data: data ? data.setStatusUniversity : null, error, submit}
}
